import { IconSearch } from '@xing-com/icons';

import * as Styled from './search-bar.styles';

type SearchBarProps = {
  value: string;
  onChange: (val: string) => void;
  placeholder: string;
};

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder,
}) => (
  <Styled.Wrapper>
    <Styled.SearchIcon>
      <IconSearch width="16" height="16" />
    </Styled.SearchIcon>
    <Styled.InputWrapper>
      <Styled.InputBar
        placeholder={placeholder}
        onKeyDown={(e) => {
          e.stopPropagation();
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        value={value}
      />
    </Styled.InputWrapper>
  </Styled.Wrapper>
);
